<template>

  <b-modal
    v-model="isVisible"
    hide-footer
    :size="isAuditoria ? 'xl' : 'lg'"
  >
    <div class="row">

      <!-- {{ 'token atencion ' + tokenAtencion }} -->

      <div class="col-12">
        <b-alert show class="p-2">
          <div v-if="atencionMedica" class="row">
            <div class="col">
              <h5> <b> Fecha / Hora: </b>{{ atencionMedica.cita.fechaCita }} {{ atencionMedica.cita.horaCita }}</h5>
              <h5> <b> Establecimiento: </b> {{ atencionMedica.cita.establecimiento.Descripcion }}</h5>
              <h5> <b> Doctor: </b> {{ doctor.nombre }}</h5>
            </div>
            
            <div class="col">
              <h5> <b> Paciente: </b> {{ paciente.identificacion}} - {{ paciente.nombre }}</h5>
              <h5> <b> Especialidad: </b> {{ doctor.especialidad }}</h5>
              <h5>
                <b>Cobertura:</b> {{ atencionMedica.cita.cobSeleccionada.descripcion }}
                <span v-if="atencionMedica.cita.codderivacion"> / codigo: {{ atencionMedica.cita.codderivacion }}</span>
              </h5>
            </div>
          </div> 
        </b-alert>
      </div>
      
      
      <div
        class="col-12 d-flex justify-content-end"
      >
        <!-- <b-button
          variant="warning"
          @click="onEditOdontogramaInicial"
        >
          Editar Odontograma Inicial
        </b-button> -->
          <b-button
          class="mx-1"
          variant="warning"
          @click="onRedirectToEditAtencion"
        >
          Editar Atencion
        </b-button>
        <b-button
          v-if="isJefeMedico"
          class="mx-1"
          variant="info"
          @click="onSendComments"
        >
          Enviar Comentarios
        </b-button>
         <b-button
          class="mx-1"
          variant="secondary"
          @click="onCorregirAtencion"
        >
          Atencion Corregida
        </b-button>
         <b-button
          v-if="isJefeMedico"
          class="mx-1"
          variant="success"
          @click="onValidarAtencion"
        >
          Validar Atencion
        </b-button>
      </div> 


      <div class="col-4 mt-2" v-if="isAuditoria">

        <InfoSignosVitales
          v-if="idPaciente"
          :idPaciente = "idPaciente"
          :idCitaActual="atencionMedica.cita.id"
          noCopyBytton
        />

        <HistorialAtenciones 
          v-if="idPaciente"
          :idPaciente = "idPaciente"
        />

        <HistorialImagenesLabs
          v-if="idPaciente"
          :idPaciente = "idPaciente"
        />

        <HistorialDerivacionesInterconsultas
          v-if="idPaciente"
          :idPaciente = "idPaciente"
        />
      </div>

      <div :class="isAuditoria ? 'col-8' : 'col-12'">

        <AtencionAnamnesis
          :tokenAtencion="tokenAtencion"
          :isAuditoria="isAuditoria"
        />

  
        <AtencionReceta
          :tokenAtencion="tokenAtencion"
          :isAuditoria="isAuditoria"
        />
  
        <AtencionExamenes
          :tokenAtencion="tokenAtencion"
          :isAuditoria="isAuditoria"
        />
  
        <AtencionImagenes
          :tokenAtencion="tokenAtencion"
          :isAuditoria="isAuditoria"
        />
  
        <AtencionTerapias
          :tokenAtencion="tokenAtencion"
          :isAuditoria="isAuditoria"
        />
  
        <AtencionProcedimientos
          :tokenAtencion="tokenAtencion"
          :isAuditoria="isAuditoria"
        />
  
        <AtencionDescansoMedico
          :tokenAtencion="tokenAtencion"
          :isAuditoria="isAuditoria"
        />

        <b-card v-if="isAuditoria">

          <b-row class="mb-1">
            <b class="col-4">Documento As400: </b>

            <b-button
              v-if="docAs400Show"
              @click="onViewFile(docAs400Show)"
              size="sm"
            >
              <i class="fa-solid fa-file"/>
            </b-button>

            <span v-if="!docAs400Show">No hay archivo</span>

          </b-row>

          
          <b-row>

            <b class="col-4">Consentimieto Informado: </b>

            <b-button
              v-if="docConsentimientoShow"
              @click="onViewFile(docConsentimientoShow)"
              size="sm"
            >
              <i class="fa-solid fa-file"/>
            </b-button>

            <span v-if="!docConsentimientoShow">No hay archivo</span>

          </b-row>
          
        </b-card> 

        <b-card v-if="isAuditoria">
          <div class="row d-flex align-items-center justify-content-center">
            <div>
              <h5 class="text-center">Firma del Paciente:</h5>
              <div style="border: 1px solid #2980b9">
                <div
                  v-if="!base64Signature"
                  style="width: 400px; height: 150px; font-size: 40px;"
                  class="d-flex align-items-center justify-content-center"
                >
                  Sin firma
                </div>

                <img
                  v-if="base64Signature"
                  :src="base64Signature" 
                  alt="Firma paciente" 
                />
              </div>
            </div>
          </div>
        </b-card>
      </div> 

    </div>
    <b-modal id="editar-odontograma-inicial" size="xl" title="Odontograma Inicial">
      <OdontogramaInicial
        :key="odontogramaOpenKey"
        :esCrear="esCrear"
        :odontogramaRecibido="odontogramaRecibido"
      />
      
       <template #modal-footer>
    <b-button
      variant="primary"
      @click="guardarOdontogramaInicial"
    >
      Guardar Cambios
    </b-button>
    <b-button
      variant="secondary"
      @click="$bvModal.hide('editar-odontograma-inicial')"
    >
      Cancelar
    </b-button>
  </template>
    </b-modal>

    <ModalViewFile
      v-if="fileToView"
      :urlFile="fileToView"
      v-model="isModalFileVisible"
    />

  </b-modal>
  
</template>

<script>
import { ModalViewFile }         from '@/shared/components';
import { InfoSignosVitales, HistorialAtenciones, HistorialImagenesLabs, HistorialDerivacionesInterconsultas }     from "@/views/atencionCita/components";
import AtencionAnamnesis         from "@/views/atencionMedica/components/AtencionModalView/AtencionAnamnesis.vue";
import AtencionReceta            from "@/views/atencionMedica/components/AtencionModalView/AtencionReceta.vue";
import AtencionExamenes          from "@/views/atencionMedica/components/AtencionModalView/AtencionExamenes.vue";
import AtencionProcedimientos    from "@/views/atencionMedica/components/AtencionModalView/AtencionProcedimientos.vue";
import AtencionImagenes          from "@/views/atencionMedica/components/AtencionModalView/AtencionImagenes.vue";
import AtencionTerapias          from "@/views/atencionMedica/components/AtencionModalView/AtencionTerapias.vue";
import AtencionDescansoMedico    from "@/views/atencionMedica/components/AtencionModalView/AtencionDescansoMedico.vue";
import { atencionMedicaService } from '@/views/atencionMedica/services';
import { mapperAtencionMedica }  from '@/views/atencionMedica/helpers';
import SemiologiaPsicologica from '../../../atencionCita/components/Anamnesis/Semiologias/SemiologiaPsicologica/SemiologiaPsicologica.vue';

import { anamnesisService } from '../../services';
import { mapState } from 'vuex';
import OdontogramaInicial from './OdontogramaInicial.vue';
import { atencionAuditoriaService } from '../../services';
import { ROLES } from '../../../../shared/constants';
import { comprobarRoles } from '../../../../shared/helpers';
import { isJefeMedico } from '../../../derivaciones/helpers';

export default {

  name: "AtencionModalInterno",

  props: {
    isAuditoria: Boolean
  },

  components: {
    AtencionAnamnesis,
    AtencionReceta,
    AtencionExamenes,
    AtencionProcedimientos,
    AtencionImagenes,
    AtencionTerapias,
    AtencionDescansoMedico,
    ModalViewFile,
    HistorialImagenesLabs,
    HistorialAtenciones,
    HistorialDerivacionesInterconsultas,
    InfoSignosVitales,
    SemiologiaPsicologica,
    OdontogramaInicial
   
  },

  created() {
    this.setTokenView();
  },


  
  data() {
    return {
      dataOdontogramaInicial:null,
      anamnesisService,
      atencionAuditoriaService,
      esCrear:false,
      odontogramaRecibido:null,
      odontograma_id:null,
      odontogramaOpenKey: 0,

      isViewModal: true,
      dataSemio:null,
      dataPsico:null,
      isVisible: false,
      atencionMedica: null,
      tokenView:null,

      fileToView: null,
      isModalFileVisible: false,

      isEditable: false,
      onlyView:false,
    };
  },

  computed: {

       ...mapState({
     
      stDataSemiologia: (state) => state.atencionCita.semiologias?.semActual,
      stDataCita: (state) => state.atencionCita.dataCita,
      stComentariosAuditoria: (state) => state.auditoria.comentariosAuditoria,
     
    }),


    tokenAtencion(){
      return this.atencionMedica?.token;
    },

    tokenAnamnesis() {
      return this.atencionMedica?.anamnesis.token;
    },

    tokenReceta(){
      return this.atencionMedica?.receta 
        ? this.atencionMedica?.receta.token
        : '000'
    },

    doctor(){
      const doctor = this.atencionMedica?.cita.doctor;
      return {
        nombre:`${doctor.idPersona.primerApellido}  ${doctor.idPersona.primerNombre}`,
        especialidad: doctor.especialidad.descripcion
      }
    },

    paciente(){
      const paciente = this.atencionMedica?.cita.paciente.persona;

      return {
        nombre:`${paciente.primerApellido}  ${paciente.primerNombre}`,
        identificacion: paciente.identificacion
      }
    },

    idPaciente() {
      return this.atencionMedica?.cita.paciente.id;
    },

    base64Signature() {
      if (!this.atencionMedica?.signature) return null

      return  `data:image/png;base64,${this.atencionMedica?.signature}`;
    },

    docAs400Show(){
      
      if (!this.atencionMedica?.docAs400) return null;
      let lastDoc = null;

      if (this.atencionMedica.docAs400 && this.atencionMedica.docAs400.length > 0) {
        lastDoc = this.atencionMedica.docAs400.reduce((latest, current) => {          
          const latestDate = new Date(latest.fechaCreacion);
          const currentDate = new Date(current.fechaCreacion);          
          return currentDate > latestDate ? current : latest;
        });
      }

      if (!lastDoc) return null;
      return lastDoc.urlsDocAs400;
    },

    docConsentimientoShow(){
      if (!this.atencionMedica?.docConsentimiento) return null;
      
      return this.atencionMedica.docConsentimiento;
    },
       isJefeMedico() {
      return comprobarRoles([
        ROLES.JEFE_MEDICO,
        ROLES.JEFE_VALIDACIONES,
        ROLES.JEFE_AUDITOR,
        ROLES.JEFE_DERIVADOR,
      ]);
    },

  },
  
  methods: {

    async onSendComments(){
      
      let comentarios = ''
      if (this.stComentariosAuditoria){
        console.log("existen comentarios", this.stComentariosAuditoria)

        comentarios = JSON.stringify(this.stComentariosAuditoria)

      }
      const enviadoAuditoria = await atencionAuditoriaService.addComentarioAuditoria(this.tokenAtencion, comentarios)
      
      if(enviadoAuditoria){
        await this.$swal.fire({
        title: 'Enviado',
        text: "Los comentarios han sido enviados a el profesional",
        icon: 'success',
       
      });
      }else{
        await this.$swal.fire({
        title: 'Error',
        text: "No se enviaron los comentarios",
        icon: 'error',
       
      });
      }
     
    },

    async onCorregirAtencion(){
      
     
      const corregidoAuditoria = await atencionAuditoriaService.changeToCorregidoAuditoria(this.tokenAtencion)
      
      if(corregidoAuditoria){
        await this.$swal.fire({
        title: 'Enviado',
        text: "Se enviaron las correcciones",
        icon: 'success',
       
      });
      }else{
        await this.$swal.fire({
        title: 'Error',
        text: "No se enviaron las correcciones",
        icon: 'error',
       
      });
      }
     
    },

    
    async onValidarAtencion(){
      
     
      const corregidoAuditoria = await atencionAuditoriaService.changeToValidadoAuditoria(this.tokenAtencion)
      
      if(corregidoAuditoria){
        await this.$swal.fire({
        title: 'Validado!',
        text: "Se revisaron las correcciones y se valido la atencion",
        icon: 'success',
       
      });
      }else{
        await this.$swal.fire({
        title: 'Error',
        text: "Ocurrio un error",
        icon: 'error',
       
      });
      }
     
    },
   
    
    async guardarOdontogramaInicial() {
      let dataOdontograma = JSON.stringify(this.stDataSemiologia)
      const dataSaved = await anamnesisService.saveOdontogramaInicial(this.stDataCita.id, dataOdontograma, this.odontograma_id)
      console.log("DATA REGISTRADA", dataSaved)
    },

    onEditOdontogramaInicial() {
      this.refreshOdontogramaRecibido();
      this.odontogramaOpenKey += 1;
      this.$bvModal.show("editar-odontograma-inicial")
    },

    refreshOdontogramaRecibido() {
      if (!this.dataOdontogramaInicial?.data) return;
      try {
        const jsonRespuesta = JSON.parse(
          JSON.parse(this.dataOdontogramaInicial.data)
        );
        this.odontogramaRecibido = jsonRespuesta?.data?.odontograma || null;
      } catch (error) {
        console.log(error);
      }
    },


    onRedirectToEditAtencion() {
      this.$router.push({
        name: "editar_atencion_medica",
        params: { token: this.tokenView }
      });
    },

    onViewFile(urlF) { 
      this.fileToView = urlF;
      this.isModalFileVisible = true;
    },

    hasPermission(permission) {
      const permisosUsuario = localStorage.getItem("permisos");
      return permisosUsuario.indexOf(permission) !== -1;
    },


    async onGetDataView( tokenAtencion ){
      this.isEditable = false;
      const data = await atencionMedicaService.getByToken(tokenAtencion);

      if (!data){
        this.$swal("Error", "La atencion no existe.", "error")
          .then(
            () => this.$router.push({ name: 'atenciones-medicas' })
          );
        return;
      }
      this.atencionMedica = mapperAtencionMedica( data );
      this.$store.commit("setRevision", { tokenAtencion:this.tokenAtencion });
      this.isVisible = true;

      this.isEditable = this.atencionMedica.estadoRevision === '1';
    },

    setTokenView(){
      this.tokenView = this.$route.query.view_atencion;  
    }
  },




  watch: {

    '$route.query.view_atencion': {
      handler(){ 
        this.setTokenView();
      },
    },

    tokenView:{
      deep:true,
      async handler(newValue){
        if(!newValue) return;
        this.onGetDataView( newValue );
      }
    },


    isVisible: {
      deep: true,
      async handler(newValue) {
        if( !newValue ) {
          // this.$store.commit("resetSemiologiaView");
          this.$router.push({ path: this.$route.path, query: {} })
        }
      }
    },

    atencionMedica: {
      deep:true,
      inmediate:true,
      async handler(nv){
        this.$store.commit('setDataCita', nv.cita)

        console.log("atencion medica", nv)
        
        if(nv && nv.semiologia ){
        try {
          let semio = JSON.parse(nv.semiologia)
          this.odontograma_id = semio?.data?.odontograma_id
          let responseOdonto = await anamnesisService.getOdontogramaById(semio.data.odontograma_id)
          this.dataOdontogramaInicial = responseOdonto
          let jsonRespuesta = JSON.parse(JSON.parse(responseOdonto.data))
          this.odontogramaRecibido = jsonRespuesta?.data?.odontograma
          
        } catch (error) {
          console.log(error)
        }
          
          
      }
    },

  },
 }
};
</script>
 
